import type { FindFn } from "@shared/models/analytics/base"
import { createBlankEvent } from "@shared/models/analytics/base"
import type { CourseEditBasic } from "@shared/models/analytics/course"
import { getPossessiveForPlanbook } from "@shared/models/analytics/planbook"
import type { PreparedAction } from "../../action-doc-builder"
import { partial } from "lodash-es"
import Patch from "@shared/models/patch-updater"
import type { Narrative } from "../create-narrative"
import defaultCourseActivity from "./default-course-activity"
import defaultCourseContext from "./default-course-context"
import defaultCourseModels from "./default-course-models"

interface Payload {
  courseId: string
  planbookId: string
  color: string
}

export default function changeCourseColorAction(payload: Payload): PreparedAction {
  return {
    name: "COURSE_CHANGE_COLOR",
    payload: payload,
    patches: patches(payload),
    undoPatches: undoPatches,
    narrative: partial(narrative, payload),
  }
}

export function patches(payload: Payload) {
  let patch = Patch.create("course", payload.courseId).set("attributes.color", payload.color).patch
  return [patch]
}

export const undoPatches = null

export function narrative(payload: Payload, findFn: FindFn, userId: string): Narrative {
  let models = defaultCourseModels(payload, findFn, userId)
  let courseTitle = models.course?.attributes.title
  let newEvent: CourseEditBasic = {
    ...createBlankEvent(),
    root_id: payload.planbookId,
    root_type: "planbook",
    date_plan_scheduled_for: null,

    primary_verb: "edit",
    primary_possessive: getPossessiveForPlanbook(findFn, userId, payload.planbookId),

    primary_object_type: "course",
    primary_object_id: payload.courseId,
    primary_object_specifier: "color",
    primary_object_id_and_ancestor_ids: null,

    adverbial_verb: null,

    adverbial_object_type: null,
    adverbial_object_id: null,
    adverbial_object_specifier: null,
    adverbial_object_id_and_ancestor_ids: null,
  }

  return {
    title: "Changed course color",
    titleForAnalytics: "Course - Changed Color",
    description: `Changed ${courseTitle}'s color to ${payload.color}`,
    context: defaultCourseContext(payload, models),
    activity: defaultCourseActivity(payload, models),
    newAnalyticsEvents: [newEvent],
  }
}
